import {
    ASSETS_EVENT_LOADING,
    LOAD_DEMO_ASSET_EVENTS,
    LOAD_ASSET_EVENTS_API,
    OPEN_EVENT,
    LOAD_EVENT_HISTORY,
    SET_ASSET_PREDICTION_FILTER_FIELD_DATA_QUERY,
    REMOVE_ASSET_FILTER
} from '../actions/eventManagement';

const initialState = {
    loadingAssetsEvent: true,
    assetsEvent: [],
    assetsEventLabel: '',
    currentPage: 0,
    totalPage: 3,
    pendingEventCount: 0,
    selectedEvent:'',
    historyReport:'',
    assetsPredictionFilterFieldData:'',
    resetAssetFilterField: '',
};

export default (state = initialState, action) => {

    switch (action.type) {
        case ASSETS_EVENT_LOADING:
            return {
                ...state,
                loadingAssetsEvent: action.payload
            };
        case LOAD_DEMO_ASSET_EVENTS:
            const demo_timeline = true
            console.log("action payload:");
            console.log(action.payload);
            let new_list = action.payload.event_list
            if (!demo_timeline){
                new_list = state.assetsEvent.concat(action.payload.event_list);
            }
            return {
                ...state,
                assetsEvent: new_list,
                assetsEventLabel: action.payload.asset_name,
                currentPage: action.payload.currentPage || initialState.currentPage,
                totalPage: action.payload.totalPage || initialState.totalPage,
            };
        case LOAD_ASSET_EVENTS_API:
            console.log("Load Events API total_pages: ");
            console.log(action.payload.total_pages);
            console.log("Current Page: ");
            console.log(action.payload.page);

            let event_list = null;
            if(!action.payload.page || action.payload.page==0){
                event_list=[];
            } else if(action.payload.page>1){
                event_list=state.assetsEvent.concat(action.payload.data);
            } else{
                event_list=action.payload.data
            }
            let pending_count=null;
            if (action.payload.pending_count){
                pending_count = action.payload.pending_count;
            } else {
                pending_count=state.pendingEventCount;
            }
            //console.log("event list");
            //console.log(event_list);
            return {
                ...state,
                assetsEvent: event_list,
                assetsEventLabel: "junk",
                pendingEventCount: pending_count,
                currentPage: action.payload.page ,
                totalPage: action.payload.total_pages ,
                loadingAssetsEvent:false
            };

        case LOAD_EVENT_HISTORY:
          console.log("Event history data: ");
          console.log(action.payload);

          return {
            ...state,
            historyReport: action.payload,
          };

        case OPEN_EVENT:
          return {
            ...state,
            selectedEvent: action.payload,
          };
        case SET_ASSET_PREDICTION_FILTER_FIELD_DATA_QUERY:
            return {
                ...state,
                assetsPredictionFilterFieldData: action.payload
            };
        case REMOVE_ASSET_FILTER:
        return {
            ...state,
          resetAssetFilterField: action.payload
        };

        default:
            return {
                ...state
            };
    }
}
